/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MinimizeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAy0lEQVR4nO2UQQrCQAxFg3dQ9EZFSCazGCagd+lFvItgcelGix6nMtXqdLQu2oigPpjtf0PID8CfiMy5MRnZoZFjnucj6AuybMn44kn4gViqIIEhUAhhqeJwZL+/hPvT3LmpmiDTDo8FbwmPBbeZsy+tXU5AC2oE159bu5iphT8I0pdsVy/I+KJLgCwb+F4wNPRTs6WouSqEvb7vubKgDmdftsukJGhfRV/XX03QdVtIQ/DqcJGGAFnWzcyDLN0uHNpQYlkFSRoOP88ZE8HHA1wRWR8AAAAASUVORK5CYII=)
 */
export const MinimizeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 4v3.59l5.3-5.3a1 1 0 1 1 1.4 1.42L16.42 9H20a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0ZM9 16.41l-5.3 5.3a1 1 0 0 1-1.4-1.42L7.58 15H4a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-3.59Z"
        className={colorClass}
      />
    </svg>
  );
};
